import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { Pending, Rejected, Blocked } from '../StatusPages';

export default function ProtectedRoute({ children }) {
  const { user, loading, userStatus, isAdmin, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-loading__spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admins bekommen keinen Status-Gate — immer Vollzugang
  if (!isAdmin) {
    if (userStatus === 'pending')  return <Pending />;
    if (userStatus === 'rejected') return <Rejected />;
    if (userStatus === 'blocked')  return <Blocked onLogout={logout} />;
  }

  return children;
}
